import React from 'react';
import { Empty, List, Tag, Typography } from 'antd';
import type { PursuitNextAction } from './pursuitWorkspaceModel';

const { Text } = Typography;

export type PursuitNextActionsProps = {
  actions: PursuitNextAction[];
  onSelect?: (action: PursuitNextAction) => void;
};

export const PursuitNextActions: React.FC<PursuitNextActionsProps> = ({ actions, onSelect }) => {
  if (!actions.length) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description="No ECLE next actions for this stage."
      />
    );
  }

  return (
    <List
      size="small"
      dataSource={actions}
      renderItem={(a, idx) => (
        <List.Item
          style={{ cursor: onSelect ? 'pointer' : undefined }}
          onClick={() => onSelect?.(a)}
        >
          <List.Item.Meta
            title={
              <span>
                <Text strong>
                  {idx + 1}. {a.label}
                </Text>{' '}
                {a.blocked ? <Tag color="error">Blocked</Tag> : <Tag color="processing">Ready</Tag>}
              </span>
            }
            description={
              <Text type="secondary">
                → {a.toStageKey}
                {a.reason ? ` · ${a.reason}` : ''}
                {a.implementation ? ` · ${a.implementation}` : ''}
              </Text>
            }
          />
        </List.Item>
      )}
    />
  );
};

export default PursuitNextActions;
